module.exports = __webpack_public_path__ + "img/amex.c49a4247.png";